import React from "react";
import axios from "axios";

import { Grid ,Form, Input, TextArea, Button, Select ,Modal, Divider,Header,Icon ,Segment,Step,Dropdown,Message,MessageHeader, MessageContent,Table,Pagination,ModalActions} from "semantic-ui-react";
import "antd/dist/antd.css";
import "../sidemenu.css";
import "../report.css";

import { reactLocalStorage } from "reactjs-localstorage";
import "react-notifications-component/dist/theme.css";
import "semantic-ui-css/semantic.min.css";
import "@brainhubeu/react-carousel/lib/style.css";
import i18n from "../i18n";
import { connect } from "react-redux";
import Menutest from "./menu.js";
import { SemanticToastContainer, toast } from "react-semantic-toasts";
import "react-semantic-toasts/styles/react-semantic-alert.css";
import { Link } from "react-router-dom";
import { selectedlanguage } from "../actions";
import { API_BASE_URL } from "../utils/endpoints";
//import Modal from "react-modal";


const modadd = {
    marginTop: "3%",
    marginLeft: "15%",
    marginRight: "15%",
    height: "auto",
    textAlign: "left",
    width:"50%"
  };
  
  const modadda = {
    marginTop: 150,
    marginLeft: "25%",
    height: "auto",
    textAlign: "right",
  };



class JobDetails extends React.Component {
  constructor() {
    super();

    this.state = {
      isSubmitting: true,
      lng: "en",
      get_error:"",
      showError:false,
      migrationCompleted:false,
      currentUserId:"",
      jobData:[],
      jobDataDetails:[],

      totalMainPage: 1,
      activeMainPage: 1,

      searchTotalPage: 1,
      searchActivePage: 1,
      searchWord: '',


      totalPageViewDetails:1,
      activePageViewDetails:1,
    
      searchTotalPageViewDetails:1,
      searchWordViewDetails: '',
      activePageSearchViewDetails:1,
      showViewDetailsPagination:false,
    
      showPagination:false,
      showSearchPagination:false,
      showSearchViewDetailsPagination:false,
      modalIsOpen: false,

      get_userId:"", 
      get_jobId:"",
      isExportDownloading:false,
      isExportDownloadingViewDetails:false
    };
    this.openModal = this.openModal.bind(this);
  }

  

  componentDidMount() {
    
    reactLocalStorage.get("authenticated");
    reactLocalStorage.get("accessToken");
    

    var lang = i18n.language;
    if (lang === "ar") {
      this.setState({isArabic:true})
      document.querySelector(".main_div_loading").style = "direction:rtl";
      document.querySelector(".ant-menu").style = "text-align:right";
      document.querySelector(".blue_color").style =
      "direction: rtl;float: right;";
        document.querySelector(".fixed_profile").style = "margin-right: 0% !important;";
    }

    var token = reactLocalStorage.get("accessToken");


    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/user/loadbytokken";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/user/loadbytokken";
    }

    var headers = { "Content-Type": "application/json", tokken: token };
    axios.get(apiBaseUrl, { headers: headers }).then(res => {
      if (res.data.result.ErrorResutl) {
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: res.data.result.ErrorResutl,
          animation: "bounce",
          time: 5000
        });
        window.location = "/app";
      } else {
        this.setState({
            migrationCompleted:res.data.result.migrationCompleted ,
            currentUserId:res.data.result.id 

        });
      

     
      
    
      }
    });
   
    var lang = i18n.language;
    if (lang === "ar") {
    
        document.querySelector(".blue_color").style =
        "text-align:right;width: 20%;white-space: pre;";
   
    }




     this.getJobData();



  }



  getJobData = () => {
   
      var token = reactLocalStorage.get('accessToken');
      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
   
      var page_num = 0;
      var body = {
        "page": page_num,
        "searchQuery": ""
      }
      if (ip.includes(s2)) {
        apiBaseUrl = API_BASE_URL + "/core/user/rest/migrations/jobs/searchJobs";
      }
      else {
        apiBaseUrl = API_BASE_URL + "/core/user/rest/migrations/jobs/searchJobs"
      }


      var headers = { 'Content-Type': 'application/json', 'token': token }
      axios.post(apiBaseUrl, body, { headers: headers })
        .then(response => {
            console.log(response);
             if (response.status === 200) {
                            if (response.data.status === "success") {
                                var newArr =[];
                                var newArr =response.data.result.jobs;
                            
                              this.setState({ jobData:newArr,isSubmitting:false,showPagination:true,showSearchPagination:false });
                              console.log(this.state.jobData)
                           
                            }
                      
                            if (response.data.status === "failed") { 
                                this.setState({isSubmitting:false , showPagination:false,
                                    showSearchPagination:false,});
                      
                              toast({
                                type: "failed",
                                title: i18n.t("failed.label"),
                                description: response.data.result.ErrorDescription,
                                animation: "bounce",
                                time: 5000
                              });
                            }
                          } else if (response.status === 204) {
                            this.setState({
                              get_error: response.data.result.ErrorDescription,
                              showError: true,
                              showPagination:false,
                              showSearchPagination:false,
                              isSubmitting: false
                            });
                      
                            toast({
                              type: "error",
                              title: i18n.t("error.label"),
                              description: i18n.t("Something_wrong.label"),
                              animation: "bounce",
                              time: 5000
                            });
                          } else {
                            this.setState({
                              get_error: response.data.result.ErrorDescription,
                              showError: true,
                              showPagination:false,
                              showSearchPagination:false,
                              isSubmitting: false
                            });
                      
                            toast({
                              type: "error",
                              title: i18n.t("error.label"),
                              description: i18n.t("Something_wrong.label"),
                              animation: "bounce",
                              time: 5000
                            });
                          }

        })
  }


  handlePaginationMain = (e, { activePage }) => {
    var token = reactLocalStorage.get('accessToken');
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    console.log(activePage);
    
    this.setState({ activeMainPage: activePage });

    var apiBaseUrl;
    var page_num = activePage - 1; // Remove "-1" if API expects 1-based indexing

    var body = {
        "page": page_num,
        "searchQuery": ""
    };
    if (ip.includes(s2)) {
        apiBaseUrl = API_BASE_URL + "/core/user/rest/migrations/jobs/searchJobs";
      }
      else {
        apiBaseUrl = API_BASE_URL + "/core/user/rest/migrations/jobs/searchJobs"
      }


      var headers = { 'Content-Type': 'application/json', 'token': token }
      axios.post(apiBaseUrl, body, { headers: headers })
        .then(response => {
            console.log(response);
             if (response.status === 200) {
                            if (response.data.status === "success") {
                                var total = Math.ceil(response.data.result.messages_count / 20);
                                var newArr =[];
                                var newArr =response.data.result.jobs;
                            
                              this.setState({ jobData:newArr,isSubmitting:false,showPagination:true,showSearchPagination:false,totalMainPage: total});
                              console.log(this.state.jobData)
                           
                            }
                      
                            if (response.data.status === "failed") { 
                                this.setState({isSubmitting:false , showPagination:false,
                                    showSearchPagination:false,});
                      
                              toast({
                                type: "failed",
                                title: i18n.t("failed.label"),
                                description: response.data.result.ErrorDescription,
                                animation: "bounce",
                                time: 5000
                              });
                            }
                          } else if (response.status === 204) {
                            this.setState({
                              get_error: response.data.result.ErrorDescription,
                              showError: true,
                              showPagination:false,
                              showSearchPagination:false,
                              isSubmitting: false
                            });
                      
                            toast({
                              type: "error",
                              title: i18n.t("error.label"),
                              description: i18n.t("Something_wrong.label"),
                              animation: "bounce",
                              time: 5000
                            });
                          } else {
                            this.setState({
                              get_error: response.data.result.ErrorDescription,
                              showError: true,
                              showPagination:false,
                              showSearchPagination:false,
                              isSubmitting: false
                            });
                      
                            toast({
                              type: "error",
                              title: i18n.t("error.label"),
                              description: i18n.t("Something_wrong.label"),
                              animation: "bounce",
                              time: 5000
                            });
                          }

        })

};


  searchChange = (event) => {
    if (event.target.value.length >= 2) {
        this.setState({
            showPagination:false,
            showPagination:true,
            searchWord: event.target.value
          })
    
      var token = reactLocalStorage.get('accessToken');
      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      this.setState({
        searchWord: event.target.value
      })
      var page_num = 0;
      var body = {
        "page": page_num,
        "searchQuery": event.target.value
      }
      if (ip.includes(s2)) {
        apiBaseUrl = API_BASE_URL + "/core/user/rest/migrations/jobs/searchJobs";
      }
      else {
        apiBaseUrl = API_BASE_URL + "/core/user/rest/migrations/jobs/searchJobs"
      }


      var headers = { 'Content-Type': 'application/json', 'token': token }
      axios.post(apiBaseUrl, body, { headers: headers })
        .then(response => {
            if (response.status === 200) {
                if (response.data.status === "success") {
                    var total = Math.ceil(response.data.result.count / 20);
                    
                    this.setState({ searchTotalPage: total });
                    var newArr =[];
                    var newArr =response.data.result.jobs;
                
                  this.setState({ jobData:newArr,isSubmitting:false , showPagination:false,
                    showSearchPagination:true,});
                  console.log(this.state.jobData)
               
                }
          
                if (response.data.status === "failed") { 
                    this.setState({isSubmitting:false , showPagination:false,
                        showSearchPagination:false,});
          
                  toast({
                    type: "failed",
                    title: i18n.t("failed.label"),
                    description: response.data.result.ErrorDescription,
                    animation: "bounce",
                    time: 5000
                  });
                }
              } else if (response.status === 204) {
                this.setState({
                  get_error: response.data.result.ErrorDescription,
                  showError: true,
                  showPagination:false,
                  showSearchPagination:false,
                  isSubmitting: false
                });
          
                toast({
                  type: "error",
                  title: i18n.t("error.label"),
                  description: i18n.t("Something_wrong.label"),
                  animation: "bounce",
                  time: 5000
                });
              } else {
                this.setState({
                  get_error: response.data.result.ErrorDescription,
                  showError: true,
                  showPagination:false,
                  showSearchPagination:false,
                  isSubmitting: false
                });
          
                toast({
                  type: "error",
                  title: i18n.t("error.label"),
                  description: i18n.t("Something_wrong.label"),
                  animation: "bounce",
                  time: 5000
                });
              }

        })
    } else {
    
      this.componentDidMount()
    }
  }



  handlePaginationChangeSearch = (e, { activePage }) => {

    console.log(activePage);

    var apiBaseUrl;
    var page_num = activePage - 1; // Remove "-1" if API expects 1-based indexing
    this.setState({ searchActivePage: activePage });

    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;

    var page_num = activePage - 1;
    var body = {
      "page": page_num,
      "searchQuery": this.state.searchWord
    }
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/migrations/jobs/searchJobs";
    }
    else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/migrations/jobs/searchJobs"
    }


    var headers = { 'Content-Type': 'application/json', 'token': token }
    axios.post(apiBaseUrl, body, { headers: headers })
      .then(response => {
        if (response.status === 200) {
            if (response.data.status === "success") {
                var total = Math.ceil(response.data.result.count / 20);
                    
                this.setState({ searchTotalPage: total });
                var newArr =[];
                var newArr =response.data.result.jobs;
            
              this.setState({ jobData:newArr,isSubmitting:false , showPagination:false,
                showSearchPagination:true,});
              console.log(this.state.jobData)
           
            }
      
            if (response.data.status === "failed") { 
                this.setState({isSubmitting:false , showPagination:false,
                    showSearchPagination:false,});
      
              toast({
                type: "failed",
                title: i18n.t("failed.label"),
                description: response.data.result.ErrorDescription,
                animation: "bounce",
                time: 5000
              });
            }
          } 

      })
  };



  openModal() {
    this.setState({modalIsOpen: true});
  }


  viewData = (userId, jobId) => {
    console.log(userId, jobId);
    this.setState({ 
        get_userId:userId, 
        get_jobId:jobId,
        isSubmitting: true
        }); 

 
    var page_num = 0;
    var body = {
      "page": page_num,
      "searchQuey": ""
    }
    
        var ip = API_BASE_URL;
        var s2 = "localhost:3000";
        var apiBaseUrl;
        if (ip.includes(s2)) {
          apiBaseUrl = `
              API_BASE_URL + "/core/user/rest/migrations/jobs/user=${userId}/job=${jobId}/searchJobdetails`
    
        } else {
          apiBaseUrl =
            API_BASE_URL + `/core/user/rest/migrations/jobs/user=${userId}/job=${jobId}/searchJobdetails`
        }
    
        var headers = { "Content-Type": "application/json", "token": reactLocalStorage.get("accessToken") };
        axios.post(apiBaseUrl, body, { headers })
        .then(response => {
            if (response.status === 200) {
                if (response.data.status === "success") {

                    if(response.data.result.messages_count==0){
                        this.setState({isSubmitting:false  });
          
                        toast({
                          type: "failed",
                          title: i18n.t("failed.label"),
                          description: "No job details found",
                          animation: "bounce",
                          time: 5000
                        });

                    }
                    if(response.data.result.messages_count!=0){

                        var total = Math.ceil(response.data.result.messages_count / 20);

                        var newArr =[];
                        var newArr =response.data.result.result;
                    
                      this.setState({ jobDataDetails:newArr,isSubmitting:false , modalIsOpen: true,totalPageViewDetails: total,showViewDetailsPagination:true});
                        
                    }
                  
                 
               
                }
          
                if (response.data.status === "failed") { 
                    this.setState({isSubmitting:false  });
          
                  toast({
                    type: "failed",
                    title: i18n.t("failed.label"),
                    description: response.data.result.ErrorDescription,
                    animation: "bounce",
                    time: 5000
                  });
                }
              } else if (response.status === 204) {
                this.setState({
                  get_error: response.data.result.ErrorDescription,
                  showError: true,
                 
                  isSubmitting: false
                });
          
                toast({
                  type: "error",
                  title: i18n.t("error.label"),
                  description: i18n.t("Something_wrong.label"),
                  animation: "bounce",
                  time: 5000
                });
              } else {
                this.setState({
                  get_error: response.data.result.ErrorDescription,
                  showError: true,
                 
                  isSubmitting: false
                });
          
                toast({
                  type: "error",
                  title: i18n.t("error.label"),
                  description: i18n.t("Something_wrong.label"),
                  animation: "bounce",
                  time: 5000
                });
              }
        })
        .catch(err => {
            console.error("API Error:", err.response ? err.response.data : err.message);
        });
  };




  handlePaginationViewDetails = (e, { activePage }) => {
    console.log(activePage);
    
    this.setState({ activePageViewDetails: activePage });

    var apiBaseUrl;
    var page_num = activePage - 1; // Remove "-1" if API expects 1-based indexing

    var body = {
        "page": page_num,
        "searchQuey": ""
    };

    if (API_BASE_URL.includes("localhost:3000")) {
        apiBaseUrl = API_BASE_URL + `/core/user/rest/migrations/jobs/user=${this.state.get_userId}/job=${this.state.get_jobId}/searchJobdetails`;
    } else {
        apiBaseUrl = `${API_BASE_URL}/core/user/rest/migrations/jobs/user=${this.state.get_userId}/job=${this.state.get_jobId}/searchJobdetails`;
    }

    var headers = { 
        "Content-Type": "application/json", 
        "token": reactLocalStorage.get("accessToken") 
    };

    axios.post(apiBaseUrl, body, { headers })
        .then(response => {
            if (response.status === 200 && response.data.status === "success") {
                if (response.data.result.messages_count === 0) {
                    this.setState({ isSubmitting: false });

                    toast({
                        type: "failed",
                        title: i18n.t("failed.label"),
                        description: "No job details found",
                        animation: "bounce",
                        time: 5000
                    });
                } else {
                    var total = Math.ceil(response.data.result.messages_count / 20);
                    this.setState({ 
                        jobDataDetails: response.data.result.result, 
                        isSubmitting: false, 
                        searchTotalPage: total 
                    });
                }
            } else {
                this.setState({ isSubmitting: false });
                toast({
                    type: "error",
                    title: i18n.t("error.label"),
                    description: response.data.result.ErrorDescription || i18n.t("Something_wrong.label"),
                    animation: "bounce",
                    time: 5000
                });
            }
        })
        .catch(err => {
            console.error("API Error:", err.response ? err.response.data : err.message);
        });
};



searchViewDetailsChange = (event) => {
    if (event.target.value.length >= 2) {
    
      
      this.setState({
        showViewDetailsPagination:false,
        showSearchViewDetailsPagination:true,
        searchWordViewDetails: event.target.value
      })
      var page_num = 0;
      var body = {
        "page": page_num,
        "searchQuey": event.target.value
      }

      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl = `
            API_BASE_URL + "/core/user/rest/migrations/jobs/user=${this.state.get_userId}/job=${this.state.get_jobId}/searchJobdetails`
  
      } else {
        apiBaseUrl =
          API_BASE_URL + `/core/user/rest/migrations/jobs/user=${this.state.get_userId}/job=${this.state.get_jobId}/searchJobdetails`
      }
  
      var headers = { "Content-Type": "application/json", "token": reactLocalStorage.get("accessToken") };
      axios.post(apiBaseUrl, body, { headers })
      .then(response => {
          if (response.status === 200) {
              if (response.data.status === "success") {
                  var total = Math.ceil(response.data.result.messages_count / 20);
                  
                  this.setState({ searchTotalPageViewDetails: total });
                  var newArr =[];
                  var newArr =response.data.result.result;
              
                this.setState({ jobDataDetails:newArr,isSubmitting:false });
                console.log(this.state.jobDataDetails)
             
              }
        
              if (response.data.status === "failed") { 
                  this.setState({isSubmitting:false , });
        
                toast({
                  type: "failed",
                  title: i18n.t("failed.label"),
                  description: response.data.result.ErrorDescription,
                  animation: "bounce",
                  time: 5000
                });
              }
            } else if (response.status === 204) {
              this.setState({
                get_error: response.data.result.ErrorDescription,
                showError: true,
               
                isSubmitting: false
              });
        
              toast({
                type: "error",
                title: i18n.t("error.label"),
                description: i18n.t("Something_wrong.label"),
                animation: "bounce",
                time: 5000
              });
            } else {
              this.setState({
                get_error: response.data.result.ErrorDescription,
                showError: true,
               
                isSubmitting: false
              });
        
              toast({
                type: "error",
                title: i18n.t("error.label"),
                description: i18n.t("Something_wrong.label"),
                animation: "bounce",
                time: 5000
              });
            }
      })
    
    } else {
    
        this.setState({
            showViewDetailsPagination:true,
            showSearchViewDetailsPagination:false,
            searchWordViewDetails: event.target.value
          })
          var page_num = 0;
          var body = {
            "page": page_num,
            "searchQuey": ""
          }
    
          var ip = API_BASE_URL;
          var s2 = "localhost:3000";
          var apiBaseUrl;
          if (ip.includes(s2)) {
            apiBaseUrl = 
                API_BASE_URL + `/core/user/rest/migrations/jobs/user=${this.state.userId}/job=${this.state.jobId}/searchJobdetails`
      
          } else {
            apiBaseUrl =
              API_BASE_URL + `/core/user/rest/migrations/jobs/user=${this.state.userId}/job=${this.state.jobId}/searchJobdetails`
          }
      
          var headers = { "Content-Type": "application/json", "token": reactLocalStorage.get("accessToken") };
          axios.post(apiBaseUrl, body, { headers })
          .then(response => {
              if (response.status === 200) {
                  if (response.data.status === "success") {
  
                      if(response.data.result.messages_count==0){
                          this.setState({isSubmitting:false  });
            
                          toast({
                            type: "failed",
                            title: i18n.t("failed.label"),
                            description: "No job details found",
                            animation: "bounce",
                            time: 5000
                          });
  
                      }
                      if(response.data.result.messages_count!=0){
  
                          var total = Math.ceil(response.data.result.messages_count / 20);
  
                          var newArr =[];
                          var newArr =response.data.result.result;
                      
                        this.setState({ jobDataDetails:newArr,isSubmitting:false , modalIsOpen: true,totalPageViewDetails: total});
                          
                      }
                    
                   
                 
                  }
            
                  if (response.data.status === "failed") { 
                      this.setState({isSubmitting:false  });
            
                    toast({
                      type: "failed",
                      title: i18n.t("failed.label"),
                      description: response.data.result.ErrorDescription,
                      animation: "bounce",
                      time: 5000
                    });
                  }
                } else if (response.status === 204) {
                  this.setState({
                    get_error: response.data.result.ErrorDescription,
                    showError: true,
                   
                    isSubmitting: false
                  });
            
                  toast({
                    type: "error",
                    title: i18n.t("error.label"),
                    description: i18n.t("Something_wrong.label"),
                    animation: "bounce",
                    time: 5000
                  });
                } else {
                  this.setState({
                    get_error: response.data.result.ErrorDescription,
                    showError: true,
                   
                    isSubmitting: false
                  });
            
                  toast({
                    type: "error",
                    title: i18n.t("error.label"),
                    description: i18n.t("Something_wrong.label"),
                    animation: "bounce",
                    time: 5000
                  });
                }
          })
          .catch(err => {
              console.error("API Error:", err.response ? err.response.data : err.message);
          });
    }
  }


handlePaginationSearchViewDetails = (e, { activePage }) => {
    console.log(activePage);
    
    this.setState({ activePageSearchViewDetails: activePage });

    var apiBaseUrl;
    var page_num = activePage - 1; // Remove "-1" if API expects 1-based indexing

    var body = {
        "page": page_num,
        "searchQuey": this.state.searchWordViewDetails
    };

    if (API_BASE_URL.includes("localhost:3000")) {
        apiBaseUrl = API_BASE_URL + `/core/user/rest/migrations/jobs/user=${this.state.get_userId}/job=${this.state.get_jobId}/searchJobdetails`;
    } else {
        apiBaseUrl = `${API_BASE_URL}/core/user/rest/migrations/jobs/user=${this.state.get_userId}/job=${this.state.get_jobId}/searchJobdetails`;
    }

    var headers = { 
        "Content-Type": "application/json", 
        "token": reactLocalStorage.get("accessToken") 
    };

    axios.post(apiBaseUrl, body, { headers })
        .then(response => {
            if (response.status === 200 && response.data.status === "success") {
                if (response.data.result.messages_count === 0) {
                    this.setState({ isSubmitting: false });

                    toast({
                        type: "failed",
                        title: i18n.t("failed.label"),
                        description: "No job details found",
                        animation: "bounce",
                        time: 5000
                    });
                } else {
                    var total = Math.ceil(response.data.result.messages_count / 20);
                    this.setState({ 
                        jobDataDetails: response.data.result.result, 
                        isSubmitting: false, 
                        searchTotalPageViewDetails: total 
                    });
                }
            } else {
                this.setState({ isSubmitting: false });
                toast({
                    type: "error",
                    title: i18n.t("error.label"),
                    description: response.data.result.ErrorDescription || i18n.t("Something_wrong.label"),
                    animation: "bounce",
                    time: 5000
                });
            }
        })
        .catch(err => {
            console.error("API Error:", err.response ? err.response.data : err.message);
        });
 
};




 
  back = () => {
    window.location = "dashboard";
  };


  exportData=(event)=> {

       var x = this;
       x.setState({ isExportDownloading: true });
        var token = reactLocalStorage.get("accessToken");
       var ip = API_BASE_URL;
       var s2 = "localhost:3000";
       var apiBaseUrl;
       var query = {}
       console.log(reactLocalStorage.get("role"));
       if (reactLocalStorage.get("role") === "ROLE_OPERATOR") {
        
        var query = { file_id: reactLocalStorage.get("user_id_login")};
      } else {
        var query = { file_id: reactLocalStorage.get("user_id_login"), user_id: reactLocalStorage.get( "old_userID") };
      }

      // var query = {file_id: reactLocalStorage.get("user_id_login"),user_id: reactLocalStorage.get( "old_userID")};

      query = encodeURI(JSON.stringify(query));
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/migrations/export/corpsms_jobs?query="+query;
   
   
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/user/rest/migrations/export/corpsms_jobs?query="+query
   
   
      }
      var headers = {
        "Content-Type": "application/json",
        token: token
      };
   
      axios
        .get(apiBaseUrl, { headers: headers })
        .then(function (response) {
          if (response.status === 202 || response.status === 200) {
            var exportcall = setInterval(function () {
   
              var token = reactLocalStorage.get("accessToken");
              var ip = API_BASE_URL;
              var s2 = "localhost:3000";
              var apiBaseUrl;
              if (ip.includes(s2)) {
                apiBaseUrl =
                  API_BASE_URL + "/core/user/rest/migrations/export/corpsms_jobs?query="+query;
           
           
              } else {
                apiBaseUrl =
                  API_BASE_URL +
                  "/core/user/rest/migrations/export/corpsms_jobs?query"+query;
           
           
              }
              var headers = {
                "Content-Type": "application/json",
                token: token
              };
   
              axios
                .get(apiBaseUrl, { headers: headers })
                .then(async function (response) {
                  if (response.status === 202) {
   
                 
   
                  }
                  else if (response.status === 200) {
   
                    toast({
                      type: "success",
                      title: 'success',
                      description: i18n.t("downloaded_successfuly.label"),
                      animation: "bounce",
                      time: 5000
                    });
   
                    clearInterval(exportcall);
   
                    x.downloadExcelFile("corpsms_jobs");
   
                  }
                })
                .catch(function (error) {
                  x.setState({ isExportDownloading: false });
   
                });
            }, 10000)
   
   
          }
         
          else {
            x.setState({ isExportDownloading: false });
            toast({
              type: 'error',
              title: 'error',
              description: i18n.t('Something_wrong.label'),
              animation: 'bounce',
              time: 5000,
   
            });
          }
        })
        .catch(function (error) {
          x.setState({ isExportDownloading: false });
   
          toast({
            type: 'error',
            title: 'error',
            description: i18n.t('Something_wrong.label'),
            animation: 'bounce',
            time: 5000,
   
          });
        });
    }
   
   
    
    downloadExcelFile = async (fileName) => {
        var ip = API_BASE_URL;
        var s2 = "localhost:3000";
      var token = reactLocalStorage.get("accessToken");
      if (ip.includes(s2)) {
        window.location =
          API_BASE_URL + `/core/user/rest/migrations/export/${fileName}_${reactLocalStorage.get("user_id_login")}/download`
          
      } else {
        window.location =
          API_BASE_URL +
          `/core/user/rest/migrations/export/${fileName}_${reactLocalStorage.get("user_id_login")}/download`
      }
      this.setState({ isExportDownloading: false });
    };


   exportDataDetails=(event)=> {

       var x = this;
       x.setState({ isExportDownloading: true });
        var token = reactLocalStorage.get("accessToken");
       var ip = API_BASE_URL;
       var s2 = "localhost:3000";
       var apiBaseUrl;
       var query = {}
       console.log(reactLocalStorage.get("role"));
       if (reactLocalStorage.get("role") === "ROLE_OPERATOR") {
        
        var query = { file_id: reactLocalStorage.get("user_id_login")};
      } else {
        var query = { file_id: reactLocalStorage.get("user_id_login"), user_id: reactLocalStorage.get( "old_userID") };
      }

      // var query = {file_id: reactLocalStorage.get("user_id_login"),user_id: reactLocalStorage.get( "old_userID")};

      query = encodeURI(JSON.stringify(query));
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + `/core/user/rest/migrations/export/corpsms_job_${this.state.get_jobId}?query=`+query;
   
   
      } else {
        apiBaseUrl =
          API_BASE_URL +
          `/core/user/rest/migrations/export/corpsms_job_${this.state.get_jobId}?query=`+query
   
   
      }
      var headers = {
        "Content-Type": "application/json",
        token: token
      };
   
      axios
        .get(apiBaseUrl, { headers: headers })
        .then(function (response) {
          if (response.status === 202 || response.status === 200) {
          var exportcall = setInterval(() => {  // Change function() to () => 
  var token = reactLocalStorage.get("accessToken");
  var ip = API_BASE_URL;
  var s2 = "localhost:3000";
  var apiBaseUrl;

  if (ip.includes(s2)) {
    apiBaseUrl =
      API_BASE_URL + "/core/user/rest/migrations/export/corpsms_jobs?query=" + query;
  } else {
    apiBaseUrl =
      API_BASE_URL +
      "/core/user/rest/migrations/export/corpsms_jobs?query=" + query;
  }

  var headers = {
    "Content-Type": "application/json",
    token: token,
  };

  axios
    .get(apiBaseUrl, { headers: headers })
    .then((response) => {  // Change function() to () => 
      if (response.status === 202) {
        // Still processing
      } else if (response.status === 200) {
        toast({
          type: "success",
          title: "success",
          description: i18n.t("downloaded_successfuly.label"),
          animation: "bounce",
          time: 5000,
        });

        clearInterval(exportcall);

        // Now 'this' correctly refers to the React component
        x.downloadExcelFileDetails("corpsms_job_"+this.state.get_jobId);
      }
    })
    .catch((error) => {  // Change function() to () => 
      x.setState({ isExportDownloading: false });
    });
}, 10000);

   
   
          }
         
          else {
            x.setState({ isExportDownloading: false });
            toast({
              type: 'error',
              title: 'error',
              description: i18n.t('Something_wrong.label'),
              animation: 'bounce',
              time: 5000,
   
            });
          }
        })
        .catch(function (error) {
          x.setState({ isExportDownloading: false });
   
          toast({
            type: 'error',
            title: 'error',
            description: i18n.t('Something_wrong.label'),
            animation: 'bounce',
            time: 5000,
   
          });
        });
    }
   
   
    
    downloadExcelFileDetails = async (fileName) => {
      console.log("Haaaaa");
        var ip = API_BASE_URL;
        var s2 = "localhost:3000";
      var token = reactLocalStorage.get("accessToken");
      if (ip.includes(s2)) {
        window.location =
          API_BASE_URL + `/core/user/rest/migrations/export/${fileName}/download`
          
      } else {
        window.location =
          API_BASE_URL +
          `/core/user/rest/migrations/export/${fileName}/download`
      }
      this.setState({ isExportDownloading: false });
    };


  render() {

    return (
      <div className="big_div">
        <Menutest />
        <div className="actionMenu" >
          <Grid columns={2} divided className="fixed_profile">
            <Grid.Row stretched className='fixed_header'>
              <Grid.Column className="grid_logo ">
              
                <Segment>
                      <h3 className="text_style blue_color">
                        {reactLocalStorage.get("lang")==="ar"?(
                      <img
                        src={require("../pictures/ArabicHedar.png")}
                        style={{width:'100% !important',height:'117px',marginTop:'8px',marginRight:'-13px'}}
                       className="himage"
                      />
                        ):(<img
                          src={require("../pictures/EnglishHedar.png")}
                          style={{width:'100% !important',height:'117px',marginLeft:'-13px',marginTop:'8px'}}
                         className="himage"
                        />)}
                      </h3>
                    </Segment>
              </Grid.Column>
            </Grid.Row>
          </Grid>
         
          <br></br><br></br><br></br><br></br>
      <div className="container_cards"  style={{paddingRight:this.state.isArabic? '':'20px'}}>

      <div >
      <br></br>
      {this.state.isSubmitting !=true?null: (
        <div className="overlay">
            <Segment raised textAlign="center" className="loading-segment" >
            <Icon name="spinner" size="large" loading />
            <p style={{marginTop:"20%"}}>Submitting...</p>
            </Segment>
        </div>
        )}



 <Segment color='black' style={{padding:'20px', minHeight:'200px'}} >
              <Form style={{padding:'20px'}}>
                  <Divider horizontal>
                    <Header as='h2'> <Icon name='tasks' color="black" />  {reactLocalStorage.get('lang')==='ar' ? 'تفاصيل الوظائف':'Job Details' } </Header>
                  </Divider>
                <br></br><br/>
               <Input
                                  size="small"
                                  icon="search"
                                  color="black"
                                  placeholder={
                                    this.state.isArabic
                                      ? "البحث عن  "
                                      : "Search By  "
                                  }
                              onChange={this.searchChange}
                                  style={{ float: this.state.isArabic ? "left":"right",marginBottom:"5px" }}
                                />

                                <Button disabled={this.state.isExportDownloading} onClick={()=>{this.exportData()}}>Export</Button>
                <Table
                  hover
                  responsive
                  border="0"
                  style={{ textAlign: this.state.isArabic ? "right" : "left" }}
                >
               <thead>
                      <tr style={{ textAlign: 'center' }}>
                     
                        <th className="th_child">Detail</th>
                        <th className="th_child">User ID</th>
                        <th className="th_child">Sender ID</th>
                        <th className="th_child1">Status</th>
                        <th className="th_child2">Service Type</th>
                        <th className='total_report'>Title</th>
                        <th className='total_report'>Content</th>
                        <th className='total_report'>Created Time</th>
                        <th className='total_report'>Send Now</th>
                        <th className='total_report'>Schedule Date</th>
                        <th className='total_report'>Is OTP</th>
                      

                      </tr>
                    </thead>
                    <tbody>
                    {this.state.jobData.map(item =>
                   
                        <tr>
                          <td className="approve_cycle" ><Button  className="view_details"   onClick={() => this.viewData(item.user_id, item.id)}>View Details</Button></td>
                          
                          <td className="bulk_data">{item.user_id}</td>
                          <td className="bulk_data">{item.sender_id}</td>
                          <td className="bulk_data">{item.status}</td>
                          <td className="bulk_data"> {item.service_type}</td>
                          <td className="bulk_data">{item.title}</td>
                          <td className="bulk_data">{item.content}</td>
                          <td className="bulk_data">{item.created_time}</td>
                          <td className="bulk_data">{item.send_now==true?"true":"false"}</td>
                          <td className="bulk_data">{item.schedule_date}</td>
                          <td className="bulk_data">{item.isOTP==true?"true":"false"}</td>
                         
                        </tr>
                   
                    )}
                    </tbody>
                </Table>
              

                  {this.state.showSearchPagination?
                     <Pagination
                     activePage={this.state.searchActivePage}
                     onPageChange={this.handlePaginationChangeSearch}
                     
                     totalPages={this.state.searchTotalPage}
                     className="page"
                     style={{ marginRight: '2.5%' }}
                   />:  <Pagination
                   activePage={this.state.activeMainPage}
                   onPageChange={this.handlePaginationMain}
                   
                   totalPages={this.state.totalMainPage}
                   className="page"
                   style={{ marginRight: '2.5%' }}
                 />} 
               
              
                  <br></br>
                  <br></br>
                   {/* Error message container */}
                  {this.state.showError !=true?null: (
                <Message negative className="error-container">
                <Icon name="exclamation circle" />
                {this.state.get_error}
                </Message>
            
          )}
                 
       
                
                   <br></br>
                   <br></br>
                   <br></br>
              </Form>
              </Segment>
             

             
              
      </div>
     
                
                <SemanticToastContainer />





<Modal
              closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
              size="tiny"
              className="add"
              open={this.state.modalIsOpen}
              onClose={()=>this.setState({
                modalIsOpen:false
              })}
              
              
              style={reactLocalStorage.get("lang") === "ar" ? modadda : modadd}
             
            >
                <Header icon="pencil alternate" content="Job Details" />
                <Modal.Content scrolling>
              <Modal.Description>
              <Input
                                  size="small"
                                  icon="search"
                                  color="black"
                                  placeholder={
                                    this.state.isArabic
                                      ? "البحث عن  "
                                      : "Search By  "
                                  }
                              onChange={this.searchViewDetailsChange}
                                  style={{ float: this.state.isArabic ? "left":"right",marginBottom:"5px" }}
                                />
                                                                <Button disabled={this.state.isExportDownloading} onClick={()=>{this.exportDataDetails()}}>Export</Button>

                 <Table
                  hover
                  responsive
                  border="0"
                  style={{ textAlign: this.state.isArabic ? "right" : "left" }}
                >
               <thead>
                      <tr style={{ textAlign: 'center' }}>
                    
                        <th className="th_child">delivery status</th>
                        <th className="th_child">message Content</th>
                        <th className="th_child">message type</th>
                        <th className="th_child1">reciepint number</th>
                        <th className="th_child2">send time</th>
            
                      </tr>
                    </thead>
                    <tbody>
                    {this.state.jobDataDetails.map(item =>
                   
                        <tr>
                          <td className="bulk_data">{item.delivery_status==null?"-":item.delivery_status}</td>
                          <td className="bulk_data">{item.message_Content==null?"-":item.message_Content}</td>
                          <td className="bulk_data">{item.message_type==null?"-":item.message_type}</td>
                          <td className="bulk_data"> {item.reciepint_number==null?"-":item.reciepint_number}</td>
                          <td className="bulk_data">{item.send_time==null?"-":item.send_time}</td>
                 
                         
                        </tr>
                   
                    )}
                    </tbody>
                </Table>
                {this.state.showViewDetailsPagination?  
                <Pagination
                    activePage={this.state.activePageViewDetails}  // Fix: Use activePage instead of defaultActivePage
                    onPageChange={this.handlePaginationViewDetails}
                    totalPages={this.state.totalPageViewDetails}
                    className="page"
                    floated={this.state.isArabic ? "left" : "right"}
                    />
                    :null}
              
                  
                {this.state.showSearchViewDetailsPagination? 
                <Pagination
                    activePage={this.state.activePageSearchViewDetails}  // Fix: Use activePage instead of defaultActivePage
                    onPageChange={this.handlePaginationSearchViewDetails}
                    totalPages={this.state.searchTotalPageViewDetails}
                    className="page"
                    floated={this.state.isArabic ? "left" : "right"}
                    />:null}

          
              </Modal.Description>
            </Modal.Content>
            <ModalActions>
        <Button color='black' onClick={() => this.setState({
                modalIsOpen:false
              })}>
          Close
        </Button>
       
      </ModalActions>
            </Modal>
          
              </div>
            </div>
          </div>
        );
      }
      }
      const mapStateToProps = state => {
      return { ...state };
      };
      export default connect(
      mapStateToProps,
      { selectedlanguage }
      )(JobDetails);




/**delivery_status
: 
"SMSC reject"
extra
: 
null
id
: 
"641c0bbc78df2582f998076e"
job_id
: 
"641c0bbc78df2582f998074b"
jvm
: 
null
message_Content
: 
"t"
message_id
: 
"641c0bbc78df2582f998076e"
message_type
: 
"corpsms"
reciepint_number
: 
"962796344263"
sendTime
: 
null
send_time
: 
"2023-03-23 11:20:13"
sender_id
: 
null
smsID
: 
""
smscId
: 
"default" */